import { getStrings } from '../Common/Localization/commonStrings';

const localizedStrings = {

  MyAccountUser: {
    strings: {
      en: {
        OutageAlertsLabel: "Outage Alerts",
        OtherAlertsLabel: "Other Notifications",
      },
      es: {
      }
    },
    common: ['globalError']
  },
  SearchBarSection: {
    strings: {
      en: {
        searchPlaceholder:"Search by location or acct. number",
        streetName:"Street Name",
        streetNumber:"Street Number",
        city:"City",
        zip:"Zip Code",
        accountNumber:"Account Number",
        searchError:"Please select a search type.",
        cityPlaceholder:"Search by city name.",
        zipPlaceholder:"Search by zip code.",
        streetNamePlaceholder:"Search by street name.",
        streetNumberPlaceholder:"Search by street number.",
        accountNumberPlaceholder:"Search by account number."
      
      },
      es: {
      }
    },
    common: ['globalError']
  },
  EmergencyAlerts: {
    strings: {
      en: {
        emergencyAlertHeader1: "Emergency ",
        emergencyAlertHeader2: "Alerts ",
        emergencyAlertHeaderSubTxt: "Stay informed about ",
        emergencyAlertHeaderSubTxt2: "Public Safety Power Shutoff (PSPS) events ",
        emergencyAlertHeaderSubTxt3: "and ",
        emergencyAlertHeaderSubTxt4: "Rotating Outages.",
        emergencyAlertTuronHeader: "Turn On Emergency Outage Alerts",
        emergencyAlertSetNotiFor: "Set alerts for: ",
        emergencyAlertEmailNotiTxt: "Email Alerts",
        emergencyAlertTextNotiTxt: "Text Alerts",
        emergencyAlertVoiceNotiTxt: "Voice Alerts",
        emergencyAlertAddEmail: "Add email",
        emergencyAlertAddPhone: "Add phone",
        emergencyAlertTurnOnBtn: 'Turn On Outage Alerts',
        emergencyAlertTnCRead: 'I have read and agree to the Terms and Conditions.',
        viewEditHeader:'View / Edit Emergency Alerts',
        viewEditSubHeader:'Set alerts for:',
        viewEditBtnTxt:'Done',
        turnOffHeader:'Turn Off Emergency Outage Alerts',
        turnoffDescription:'Are you sure you want to turn off Emergency Outage Alerts for this Account?',
        turnOffBtn:'Yes, Turn Off Outage Alerts',
        cancelButton:'Cancel',
        removeButton:'Remove',
        editButton:'Edit',
        errorMsg:'Something went wrong on our end.',
        Resubmit:'Click here to resubmit',
        addBtnName:'Add',
        saveBtnName:'Save',
        emergencyAlertShowMore: 'Show More',
        emergencyAlertShowLess: 'Show Less',
        emailSameValueErrorMsg:'Email already exists',
        voiceSameValueErrorMsg:"Phone number already exists",
        textSameValueErrorMsg:"Phone number already exists",
        atleastOnePrefErrMsg:'You must add at least one contact for notifications.',
        limitText:'(limit 3 contacts)',
        printText:'Print',
        emailText:'email',
        emailInvalidText:'Please enter a valid email id.',
        phnInvalidText:'Please enter a valid phone number.',
        warningHeading: 'IMPORTANT!',
        warningText1: 'Please consider staying enrolled in outage alerts.',
        warningText2: 'They may help keep you safer by notifying you when there are emergency-related outages.',
        warningText3: 'Are you sure you want to opt out of receiving outage alerts?',
        disablePopupText: 'You will always receive critical emergency outage alerts, with the flexibility to update your contact information.',
        tncError:"You must agree to the Terms and Conditions."
      },
      es: {
      }
    },
    common: ['globalError', 'cancel']
  },


};
export const getLocalizedStringstwo = (componentName) => {
  app.logger.getLogger().debug("Comp Name" + componentName);
  var strings = getStrings(localizedStrings[componentName].strings,
    localizedStrings[componentName].common, true);
  return strings;
};